export const statusLabels = {
  observed: "Sourced evidence",
  stale: "Older evidence",
  calculated: "Calculated scenario",
  user_provided: "Your input",
  assumed: "Assumption",
  unavailable: "Not assessed",
};
export const scopeLabels = {
  parcel: "Parcel",
  address_point: "Address point",
  postcode: "Postcode",
  SAL: "Suburb",
  SA2: "Statistical area",
  LGA: "Council area",
};
export function displayDate(value) {
  if (!value) return "Not recorded";
  const date = new Date(value);
  return Number.isNaN(date.getTime())
    ? value
    : date.toLocaleDateString("en-AU", {
        day: "numeric",
        month: "short",
        year: "numeric",
      });
}
export function metricValue(metric) {
  if (
    !metric ||
    metric.value === null ||
    metric.value === undefined ||
    metric.status === "unavailable"
  )
    return "Not assessed";
  if (
    ["AUD", "AUD/week"].includes(metric.unit) &&
    typeof metric.value === "number"
  )
    return (
      new Intl.NumberFormat("en-AU", {
        style: "currency",
        currency: "AUD",
        maximumFractionDigits: 0,
      }).format(metric.value) + (metric.unit === "AUD/week" ? " / week" : "")
    );
  return `${metric.value}${metric.unit === "%" ? "%" : ""}`;
}
export function openCalculator(id) {
  const panel = document.getElementById(id);
  if (!panel) return;
  panel.open = true;
  panel.scrollIntoView({ block: "start" });
  panel.querySelector("summary")?.focus();
}
